export const faqData: any[] = [
  {
    answer:
      'Signing up for an Arcadia account allows us to check your eligibility and enroll you in our community solar program. You’ll get updates on how your solar farm is performing, along with monthly savings notifications.',
    name: 'signup',
    question: 'Why do I need an Arcadia account?',
  },
  {
    answer:
      'Opting in for SMS updates allows us to provide you with timely notifications regarding your solar farm status and monthly savings. We do not sell your data to third-parties and we will never send spam messages. You can opt-out at any time. ',
    name: 'sms',
    question: 'Why should I opt-in to SMS updates?',
  },
  {
    answer:
      'It’s entirely free to sign up and there are no ongoing costs to participate. If you qualify as a low- or moderate-income household we will be able to connect you to a solar farm that generates monthly savings on your utility bill.',
    name: 'cost',
    question: 'Does this cost anything?',
  },
  {
    answer:
      'You’ll provide us with information about your utility account so that we can maximize your savings and confirm your qualification for the program.',
    name: 'whatnext',
    question: 'What happens next?',
  },
  {
    answer: (() => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        If you don't qualify, there is unfortunately no other option to sign up for community solar
        with Arcadia in Ohio at this time. We will keep you posted if Ohio establishes additional
        opportunities for more folks to sign up for community solar in the future.
      </div>
    ))(),
    name: 'qualify',
    question: 'What if I don’t qualify as a low- or moderate-income household?',
  },
];
